/**
 * @generated SignedSource<<65a0c0d2951c8f6f84c344c3564c0df1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type team_issueFieldTeamInlineEditFull_TeamInlineEditView_fragmentRef$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "team_issueFieldTeamInlineEditFull_TeamInlineEditView_fragmentRef";
};
export type team_issueFieldTeamInlineEditFull_TeamInlineEditView_fragmentRef$key = {
  readonly " $data"?: team_issueFieldTeamInlineEditFull_TeamInlineEditView_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"team_issueFieldTeamInlineEditFull_TeamInlineEditView_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditView_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    }
  ],
  "type": "JiraTeamViewField"
};

(node as any).hash = "10546ea9458e9373d43b23a6a4446d16";

export default node;
